import React from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const DateSideBar = () => {

    const currentDate = new Date();

    return (
        <div className="container-date-sidebar">
            <div className="date-sidebar" style={{ marginLeft: "20px" }}>{dayjs(currentDate).format("HH:mm")}</div>
            <div className="date-sidebar" style={{ fontWeight: 300, opacity: 0.87, marginLeft: "20px" }}>
                {dayjs(currentDate).format("DD.MM")}
            </div>
        </div>
    );
};

export default DateSideBar;
